import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

type ResourcePanelView = 'list' | 'air_ambulance';

interface ResourceRequestsState {
  selectedRequest: string | null;
  isResourcePanelOpen: boolean;
  resourcePanelView: ResourcePanelView;
}

const initialState: ResourceRequestsState = {
  selectedRequest: null,
  isResourcePanelOpen: false,
  resourcePanelView: 'list',
};

/**
 * Manages the UI state for the right-hand resource requests panel. See
 * etlIntegrationsApi & hooks for the actual resource request data (e.g. GMR/Air
 * Ambulance transports) are cached under the api key in redux.
 */
const resourceRequestsSlice = createSlice({
  name: 'resourceRequests',
  initialState,
  reducers: {
    setSelectedRequest: (state, action: PayloadAction<string | null>) => {
      state.selectedRequest = action.payload;
    },
    openResourcePanel: state => {
      state.isResourcePanelOpen = true;
    },
    closeResourcePanel: state => {
      state.isResourcePanelOpen = false;
      state.resourcePanelView = 'list';
      state.selectedRequest = null;
    },
    setResourcePanelView: (state, action: PayloadAction<ResourcePanelView>) => {
      state.resourcePanelView = action.payload;
    },
    toggleResourcePanel: state => {
      state.isResourcePanelOpen = !state.isResourcePanelOpen;
    },
  },
  selectors: {
    selectSelectedRequestId: state => state.selectedRequest,
    selectIsResourcePanelOpen: state => state.isResourcePanelOpen,
    selectResourcePanelView: state => state.resourcePanelView,
  },
});

export const {
  setSelectedRequest,
  openResourcePanel,
  closeResourcePanel,
  setResourcePanelView,
  toggleResourcePanel,
} = resourceRequestsSlice.actions;

export const {
  selectSelectedRequestId,
  selectIsResourcePanelOpen,
  selectResourcePanelView,
} = resourceRequestsSlice.selectors;

export type { ResourcePanelView };
export default resourceRequestsSlice.reducer;
